import store from '@/store'
import _ from 'lodash'

export default {
  bind(el, binding, vnode) {
    const siteIsInEditMode = _.get(store.getters, 'clientModel.inEditMode')

    if (siteIsInEditMode) {
      el.setAttribute('data-epi-edit', binding.value)
    }
  }
}
